<template>
  <div id="quote" class="quote">
    <div class="list-card">
      <div class="card-title">
        <span>{{ data.startCityZipcode }}, {{ data.startCityNameEn }} > #{{ data.storeCode }} -
          {{ data.destCityNameEn }},{{ data.destProvinceNameEn }},{{ data.destCountryNameEn }}</span>
      </div>
      <div class="card-table">
        <table>
          <tr>
            <td>Fee code</td>
            <td>Fee name</td>
            <td>Comment</td>
            <td>Units</td>
            <td>Units price</td>
            <td>Amount</td>
          </tr>
          <tr>
            <td>FBA FREIGHT</td>
            <td>FBA FREIGHT</td>
            <td>FBA FREIGHT</td>
            <td>{{ data.orderChargeWeight }}</td>
            <td>US ${{ (data.orderTransferFee/data.orderChargeWeight).toFixed(2) }}</td>
            <td>US ${{ data.orderTransferFee }}</td>
          </tr>
          <tr v-for="feeItem in data.feeList">
            <td>{{ feeItem.feeCode }}</td>
            <td>{{ feeItem.feeNameEn }}</td>
            <td>{{ feeItem.commentEn }}</td>
            <td>{{ feeItem.feeUnit }}</td>
            <td>US ${{ feeItem.unitPrice }}</td>
            <td>US ${{ feeItem.totalAmount }}</td>
          </tr>
          <tr v-if="data.startLiftgateAmount>0">
            <td>LIFT</td>
            <td>Lift Gate Charge</td>
            <td>Flat Fee</td>
            <td>1</td>
            <td>US ${{ data.startLiftgateAmount }}</td>
            <td>US ${{ data.startLiftgateAmount }}</td>
          </tr>
        </table>
      </div>
      <div class="card-subtotal">
        <span>Subtotal: US ${{ data.subTotal1 }}</span>
      </div>
      <div v-if="data.buyInsurance==1">
        <div class="card-title">
          <span>Insurance</span>
        </div>
        <div class="card-table">
          <table>
            <tr>
              <td>Fee code</td>
              <td>Comment</td>
              <td>Amount</td>
            </tr>
            <tr>
              <td>Insurance (based on goods value of USD {{ data.totalValue }})</td>
              <td>-</td>
              <td>US ${{ data.insuranceInfo.insuranceAmount }}</td>
            </tr>
          </table>
        </div>
        <div class="card-subtotal">
          <span>Subtotal: US ${{ data.insuranceInfo.insuranceAmount }}</span>
        </div>
      </div>

      <div class="card-total">
        <span>Total: US ${{ data.totalAmount }}</span>
      </div>
      <div class="card-remarks">
        <p>LCL Service</p>
        <slot v-for="item in data.channelDetail">
          <p>{{ item.moduleNameEn }}:</p>
          <span>
            {{ item.contentEn }}
          </span>
        </slot>

      </div>
    </div>
  </div>
</template>

<script>
import {
  GetExpOrderDetail
} from '@/api/order.js'
export default {
  name: 'Quote',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      list: []
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    init(data) {
      GetExpOrderDetail(data.orderNo).then(res => {
        if (res.code === 200) {
          this.data = res.data
          this.data.subTotal1 = this.data.orderTransferFee
          if (this.data.feeList) {
            this.data.feeList.forEach(item => {
              this.data.subTotal1 += item.totalAmount
            })
          }
          this.data.subTotal1 += this.data.startLiftgateAmount
          this.data.totalAmount = (this.data.subTotal1 + this.data.insuranceInfo.insuranceAmount)
            .toFixed(3)
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.quote {
		width: 1152px;
		height: auto;
		background: #FFFFFF;
		border-radius: 8px;
		margin-top: 16px;
		padding: 24px;

		.list-card {
			.card-title {
				width: 100%;
				height: 40px;
				background: rgba(170, 170, 170, 0.08);
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				line-height: 40px;
				text-align: left;

				span {
					margin-left: 16px;
				}
			}

			.card-table {
				table {
					width: 100%;
					border-collapse: collapse;
					text-align: left;
					padding: 0 8px;

					tr:nth-of-type(1) {
						td {
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 550;
							color: #333333;
						}
					}

					tr {
						height: 40px;

						td {
							border-bottom: 1px solid rgba(170, 170, 170, 0.24);
							font-size: 13px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							color: #333333;
							padding: 0 16px;
						}

						td:last-child {
							text-align: right;
						}
					}
				}
			}

			.card-subtotal {
				font-size: 14px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: right;
				padding-right: 16px;
			}

			.card-total {
				height: 40px;
				line-height: 40px;
				text-align: right;
				background: rgba(2, 127, 252, 0.08);
				font-size: 16px;
				font-family: D-DINExp, D-DINExp;
				font-weight: bold;
				color: #333333;
				padding-right: 16px;
			}

			.card-remarks {
				width: 100%;
				height: 161px;
				background: rgba(0, 0, 0, 0.02);
				border-radius: 8px;
				margin: 16px 0;
				text-align: left;
				overflow-y: scroll;

				p {
					padding: 4px 8px;
					margin: 0;
				}

				span {
					padding: 0 8px;
					display: block;
				}
			}
		}
	}
</style>
